const RTL_LOCALES = new Set(['ar', 'he', 'fa', 'ur']);

export function resolveParticipantTextDirection(locale) {
  const normalized = String(locale || 'en').trim().toLowerCase().split('-')[0];

  return RTL_LOCALES.has(normalized) ? 'rtl' : 'ltr';
}

export function resolveParticipantHtmlLang(locale) {
  const normalized = String(locale || 'en').trim().toLowerCase().replace(/_/g, '-');

  if (normalized === 'pt-pt') {
    return 'pt';
  }

  if (normalized.includes('-')) {
    return normalized;
  }

  return normalized;
}
